module.exports = __webpack_public_path__ + "static/media/haxe.3211f80a.svg";